import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import PagoDepositoExtraccionQrService from "../../../../services/operaciones-qr/PagoDepositoExtraccionQrService";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faFilePdf, faPlus } from "@fortawesome/free-solid-svg-icons";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import TransferQrService from "../../../../services/transferencias/TransferQrService";


export default class PagoDepositoExtraccionQrPaso4 extends Component {
  constructor(props) {
    super(props);
  }

  descargar = async () => {
    var data = JSON.stringify({
      titulo: this.props.datosTipoQR.titulo,
      nroSocioTitular: AuthService.getSocio().numeroSocio + " - " + AuthService.getSocio().nombreCompleto.trim(),
      nroOperacion: String(this.props.nroOperacion),
      formaPago: this.props.formaPago + ": " + this.props.datoPago,
      formaPagoDetalle: this.props.datosTipoQR.formaPago,
      comercio: this.props.comercio,
      documento: this.props.datosQR.docDestinatario,
      monto: " GS." + this.props.importe ,
      fechaOperacion: (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) 
    });

    await trackPromise(
      PagoDepositoExtraccionQrService.descargarComprobante(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };

  descargarCompTransf = async () => {

    var data = JSON.stringify({
      titulo: "Transferencia por QR", //
      nroOperacion: this.props.nroOperacion,//
      cuentaTitular: this.props.cuentaOrigen.ahorro +" - " +AuthService.getSocio().nombreCompleto.trim(),//
      tipo: this.props.cuentaOrigen.descripcion,//
      moneda: this.props.cuentaOrigen.moneda,//
      cuentaCredito: this.props.datosQR.numCuentaDestino,//
      importeDebito: this.props.importe ,//
      importeCredito: this.props.importe ,//
      titularCuentaDestino: this.props.datosQR.titularDestinatario,//
      motivo: this.props.motivo,
      fechaOperacion: (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) 
    });

    await trackPromise(
      TransferQrService.descargarComprobante(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };

  render() {
    if (this.props.currentStep === 4) {
      if(this.props.datosQR.origenQr == 'BANCARDATM'){
        mensajeExito("La Validación se Realizó Exitosamente");
      } else {
        mensajeExito("La Operación se Realizó Correctamente");
      }      
    } 

    if(this.props.datosQR.codOperacion == 'TRANF'){
      return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Leer código QR
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos del QR</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}                        
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <div className="invoice p-3 mb-3">
              <div className="row">
                <div className="col-8" style={{ marginBottom: 5 }}>
                  <h6 style={{ margin: 0 }}>
                    Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                    {AuthService.getSocio().nombreCompleto.trim()}
                  </h6>
                  <p style={{ marginBottom: 0 }}>
                    Tipo: {this.props.cuentaOrigen.descripcion}
                  </p>
                  <p>Moneda: {this.props.cuentaOrigen.moneda}</p>
                </div>
              </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Cuenta Crédito:</th>
                          <td>{this.props.datosQR.numCuentaDestino}</td>
                        </tr>
                        <tr>
                          <th>Importe del Crédito:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "}
                            {this.props.cuentaOrigen.moneda}.
                          </td>
                        </tr>
                        <tr>
                          <th>Titular de la cuenta destino:</th>
                          <td>{this.props.datosQR.titularDestinatario}</td>
                        </tr>
                        {/* <tr>
                          <th>Tipo documento de la cuenta destino:</th>
                          <td>{this.props.datosQR.tipoDocDestino}</td>
                        </tr> */}
                        <tr>
                          <th>Documento de la cuenta destino:</th>
                          <td>{this.props.datosQR.docDestinatario}</td>
                        </tr>
                        <tr>
                          <th>Motivo:</th>
                          <td>{this.props.motivo}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <MensajeUsuario tipo="INFO" 
                                  titulo="Importante!" 
                                  mensaje="El límite diario es de 6.000.000 Gs. (establecido por Bancard)." />                           
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-lg-8 col-md-6"></div>
          <div className="col-lg-2 col-md-3 btn-consulta">
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            onClick={this.props.firstStep}
          ></button>
            <button
            className="btn btn-cu-quintary"
            onClick={(e) => {
              this.props.returnDataPaso4();
              this.nextStep.click();
            }}
          >
           <FontAwesomeIcon icon={faAdd} /> Nueva Transacción
          </button>
          </div>
          <div className="col-lg-2 col-md-3">
          <button className="btn btn-cu-primary" onClick={this.descargarCompTransf}>
           <FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante
          </button>
          </div>
        </div>
      </div>
    );
    }

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Leer código QR
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos del QR</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        {this.props.datosQR.origenQr !== 'BANCARDATM' && (
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}                        
            </p>
          </div>
        </div>
        )}
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <div className="invoice p-3 mb-3">
              <h6>
                {this.props.datosTipoQR.titulo} 
              </h6>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>{this.props.datosTipoQR.atmOComercio}:</th>
                          <td>{this.props.comercio}</td>
                        </tr>
                        <tr>
                          <th>Titular de la {this.props.tipoFondo}:</th>
                          <td>{AuthService.getSocio().nombreCompleto.trim()}</td>
                        </tr>
                        <tr>
                          <th>{this.props.datosTipoQR.formaPago}:</th>
                          <td>{this.props.formaPago}</td>
                        </tr>                        
                        <tr>
                          <th>Datos de {this.props.datosTipoQR.tipoQR}:</th>
                          <td>{this.props.datoPago}</td>
                        </tr>
                        {this.props.datosQR.origenQr !== 'BANCARDATM' && (
                        <tr>
                          <th>Total a {this.props.datosTipoQR.accionQR}:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "} GS.
                          </td>
                        </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-md-6"></div>
          <div className="col-lg-2 col-md-3">
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            onClick={this.props.firstStep}
          ></button>
          <button
            className="btn btn-cu-quintary btn-consulta"
            onClick={(e) => {
              this.props.returnDataPaso4();
              this.nextStep.click();
            }}
          >
          <FontAwesomeIcon icon={faPlus} />   Nueva Operación
          </button>
          
        </div>
        <div className="col-lg-2 col-md-3">
        {this.props.datosQR.origenQr !== 'BANCARDATM' && (

        <button className="btn btn-cu-primary" onClick={this.descargar}>
        <FontAwesomeIcon icon={faFilePdf} />  Descargar Comprobante
        </button>

        )}
        </div>
        </div>
      </div>
    );
  }
}
